const TYPE_LICENSE = Object.freeze({
  "OBTAINED_IN_COUNTRY": 'OBF',
  "INTERNATIONAL": "INT"
});

export default Object.freeze({
    TYPE: TYPE_LICENSE
});